<script lang="typescript">
    import { createEventDispatcher } from "svelte"
    import SvelteMarkdown from "svelte-markdown/src/SvelteMarkdown.svelte"
    import { get_all_dirty_from_scope } from "svelte/internal"

    import { scale } from "svelte/transition"
    import { getUser } from "../api"
    import EntryDialog from "./EntryDialog.svelte"
    import Symbol from "./Symbol.svelte"
    import SymbolSelector from "./SymbolSelector.svelte"
    import UserSelector from "./UserSelector.svelte"

    export let items: PlanEntry[]

    const detach = createEventDispatcher()

    async function assignUser(e: PlanEntry, userId: number) {
        if (e.user.id != userId) {
            e.user_id = userId
            detach("userUpdate", e)
        }
    }

    async function assingSymbol(e: PlanEntry, symbolCode: SymbolCode) {
        if (e.symbol != symbolCode) {
            e.symbol = symbolCode
            detach("symbolUpdate", e)
        }
    }

    let editItem: PlanEntry

    const now = Date.now()
</script>

<style lang="less">
    .item {
        &.betweenDate {
            background-color: rgba(255, 255, 0, 0.05);
        }
        &.overdue {
            background-color: rgba(255, 0, 0, 0.05) !important;
        }
        &.done {
            background-color: rgba(0, 155, 66, 0.1);
        }
    }
</style>

{#if items?.length}
    {#each items as p (p.id)}
        {#if !editItem || editItem != p}
            <div
                class="item"
                class:serie="{!!p.series_id}"
                transition:scale
                class:overdue="{new Date(Date.now() - 1000 * 60 * 60 * 24) >
                    new Date(p.ends_on) && p.symbol != 12}"
                class:betweenDate="{new Date(p.starts_on).getTime() <= now}"
                class:done="{p.symbol == 12}"
                on:click="{() => {
                    editItem = p
                }}"
            >
                <div
                    class="checkbox"
                    class:active="{p.symbol == 12}"
                    style="border:solid 1px {p.color ||
                        p.project?.color ||
                        '#999'}; background-color:{p.color ||
                        p.project?.color ||
                        '#999'};"
                    on:click|stopPropagation="{() => {
                        assingSymbol(p, 12)
                    }}"
                ></div>
                <div class="inner">
                    <div class="title">
                        <div
                            class="headline"
                            title="{p.project?.customer_name ||
                                p.project?.customer?.name} // {p.project?.name}"
                        >
                            {p.title}
                        </div>
                        <div class="project">
                            {p.project?.customer_name ||
                                p.project?.customer?.name} // {p.project?.name}
                        </div>
                        {#if p.comment}
                            <div class="comment">
                                <SvelteMarkdown
                                    source="{p.comment}"
                                    options="{{
                                        breaks: false,
                                        smartLists: true,
                                    }}"
                                />
                            </div>
                        {/if}
                    </div>
                    <div>
                        {#if p.starts_on}
                            <span
                                >{#if p.starts_on}{new Date(
                                        p.starts_on
                                    ).toLocaleDateString("de", {
                                        year: "2-digit",
                                        month: "2-digit",
                                        day: "2-digit",
                                    })}{/if}
                                <span>bis</span
                                >
                                {#if p.ends_on}
                                    {new Date(p.ends_on).toLocaleDateString(
                                        "de",
                                        {
                                            year: "2-digit",
                                            month: "2-digit",
                                            day: "2-digit",
                                        }
                                    )}{/if}</span
                            >
                            {#if p.hours_per_day}
                                {p.hours_per_day}h
                                <span style="font-size: 0.8em; color: #555;"
                                    >/ Tag {#if p.series_id}(Serie){/if}</span
                                >
                            {/if}
                        {:else if p.sort}
                            Prio {p.sort}
                        {/if}
                    </div>
                    <div class="settings">
                        {#await getUser(p.user.id) then user}
                            {#if p.series_id}
                                <div>
                                    <img
                                        src="{user.avatar_url}"
                                        alt=""
                                        style="width:30px; border-radius: 30px; cursor: not-allowed;"
                                    />
                                </div>
                            {:else}
                                <UserSelector
                                    user="{user}"
                                    on:selected="{(e) => {
                                        assignUser(p, e.detail.id)
                                    }}"
                                />
                            {/if}
                        {/await}
                        {#if p.series_id}
                            <div
                                style="cursor: not-allowed; margin-left: 20px;"
                            >
                                <Symbol symbolCode="{p.symbol}" />
                            </div>
                        {:else}
                            <SymbolSelector
                                symbolCode="{p.symbol}"
                                on:selected="{(e) => {
                                    assingSymbol(
                                        p,
                                        // @ts-ignore
                                        e.detail ? e.detail : null
                                    )
                                }}"
                            />
                        {/if}
                    </div>
                </div>
            </div>
        {:else}
            <div class="item" in:scale="{{ delay: 300 }}" style="cursor:auto;">
                <EntryDialog
                    data="{{
                        ...editItem,
                        user_id: editItem.user_id || editItem.user?.id,
                        project_id: editItem.project_id || editItem.project?.id,
                    }}"
                    on:cancel="{() => {
                        editItem = null
                    }}"
                    on:submit="{(e) => {
                        editItem = null
                        detach('update', e.detail)
                    }}"
                    on:delete="{(e) => {
                        editItem = null
                        detach('delete', e.detail)
                    }}"
                />
            </div>
        {/if}
    {/each}
{/if}
